import React from 'react';
import { BookOpen, CheckCircle2 } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const modules = [{
  num: '1',
  title: 'Entendiendo la Celiaquía',
  subtitle: 'Aprendé cómo cuidar correctamente tu salud.',
  bullets: ['Qué es la celiaquía.', 'Alimentos prohibidos.', 'Contaminación cruzada.', 'Cómo leer etiquetas.']
}, {
  num: '2',
  title: 'Organización de Comidas Sin Gluten',
  subtitle: 'Dejá de improvisar tu alimentación.',
  bullets: ['Planificación semanal.', 'Horarios recomendados.', 'Cómo organizar compras.', 'Comidas rápidas y saludables.']
}, {
  num: '3',
  title: 'Recetas Saludables para Todos los Días',
  subtitle: 'Opciones fáciles, nutritivas y deliciosas.',
  bullets: ['Desayunos.', 'Almuerzos.', 'Cenas.', 'Snacks y colaciones.']
}, {
  num: '4',
  title: 'Alimentación Según Cada Edad',
  subtitle: 'Consejos específicos para cada etapa de vida.',
  bullets: ['Niños.', 'Adolescentes.', 'Adultos.', 'Adultos mayores.']
}, {
  num: '5',
  title: 'Hábitos Saludables y Bienestar',
  subtitle: 'Cómo mejorar tu calidad de vida diaria.',
  bullets: ['Hidratación.', 'Ejercicio recomendado.', 'Descanso.', 'Alimentación consciente.']
}, {
  num: '6',
  title: 'Vida Saludable Sin Gluten',
  subtitle: 'Aprendé a mantener hábitos saludables a largo plazo.',
  bullets: ['Organización personal.', 'Alimentación equilibrada.', 'Prevención de síntomas.', 'Bienestar físico y emocional.']
}];
export function Modules() {
  return <section className="py-24 bg-cream-100" data-id="element-113">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-115">
          <FadeIn data-id="element-116">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-100 text-brand-600 mb-6" data-id="element-117">
              <BookOpen className="w-8 h-8" data-id="element-118" />
            </div>
            <h2 className="text-sm font-bold tracking-widest text-brand-600 uppercase mb-3" data-id="element-119">
              CONTENIDO COMPLETO
            </h2>
            <p className="text-4xl md:text-5xl font-serif font-bold text-brand-950" data-id="element-120">
              LOS 6 MÓDULOS
            </p>
          </FadeIn>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-10" data-id="element-121">
          {modules.map((mod, idx) => <FadeIn key={idx} delay={idx * 0.1} className="bg-white rounded-[2rem] p-8 md:p-10 shadow-soft border border-brand-50 relative overflow-hidden group hover:shadow-soft-lg transition-all" data-id="element-122">
              {/* Decorative large number */}
              <div className="absolute -right-4 -top-8 text-[12rem] font-serif font-bold text-brand-50 opacity-50 group-hover:scale-110 transition-transform duration-500 pointer-events-none" data-id="element-123">
                {mod.num}
              </div>

              <div className="relative z-10" data-id="element-124">
                <div className="inline-block px-4 py-1.5 rounded-full bg-brand-100 text-brand-700 text-sm font-bold mb-6" data-id="element-125">
                  MÓDULO {mod.num}
                </div>

                <h3 className="text-2xl md:text-3xl font-serif font-bold text-brand-950 mb-3" data-id="element-126">
                  {mod.title}
                </h3>

                <p className="text-brand-600 font-medium mb-8 text-lg" data-id="element-127">
                  {mod.subtitle}
                </p>

                <ul className="space-y-4" data-id="element-128">
                  {mod.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start gap-3" data-id="element-129">
                      <CheckCircle2 className="w-6 h-6 text-brand-400 flex-shrink-0 mt-0.5" data-id="element-130" />
                      <span className="text-brand-800 font-medium" data-id="element-131">
                        {bullet}
                      </span>
                    </li>)}
                </ul>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}